// extracted by mini-css-extract-plugin
export default {"banner":"BdFiAIKHgyavuLLNjCzm","icon":"bxhO2X8NbhBe7id14YoY","boldDate":"m2GwnNrLVDupcD_RAUAO","action":"ieTx0d7QV4f0MDkRjhbZ"};